import '@babel/polyfill';
import Router from './router.js';

Router.start();
